import EmployeeResponsibility from "./EmployeeResponsibility";

export default EmployeeResponsibility;
